<template>
  <div v-loading="loading">
    <div class="header-actions">
      <search-input
        placeholder="Поиск по названию"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>
      <div slot="right">
        <div class="el-row--flex">
          <el-button
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="openAddDialog"
          >
            Добавить компетенции
          </el-button>
        </div>
      </div>
    </div>

    <div class="profile_competencies-block">
      <el-table :data="profile_competencies" border>
        <el-table-column prop="competence.name" label="Название" width="500"></el-table-column>
        <el-table-column prop="competence.description" label="Описание"></el-table-column>
        <el-table-column width="250" prop="target_score" label="Целевой уровень">
          <template v-slot="scope">
            <click-to-edit
              :word-limit="6"
              :show-word-limit="true"
              :number-format="{decimals: 2, space:true}"
              digits-only
              style="width: 220px"
              v-model="scope.row.target_score"
              @input="updateProfileCompetence(scope.row)"
            ></click-to-edit>
          </template>
        </el-table-column>
        <el-table-column width="90" align="center" label="Действия">
          <template v-slot="scope">
            <el-popconfirm
              confirm-button-text='Да'
              cancel-button-text='нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить компетенцию с профиля?"
              @confirm="deleteProfileCompetence(scope.row)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <add-profile-competencies-dialog
      ref="addDialog"
      @profile-competence-saved="loadProfileCompetencies"
    >
    </add-profile-competencies-dialog>
  </div>
</template>

<script>
import SearchInput from "@/components/filters/SearchInput.vue";
import ClickToEdit from "@/components/ClickToEdit.vue";
import AddProfileCompetenciesDialog from "@/modules/evaluation/components/profile/AddProfileCompetenciesDialog.vue";

export default {
  name: "profile-competencies",
  components: {AddProfileCompetenciesDialog, ClickToEdit, SearchInput},
  data() {
    return {
      loading: false,
      profile_competencies: [],
      filters: {},
    }
  },
  mounted() {
    this.loadProfileCompetencies();
  },
  methods: {
    openAddDialog() {
      this.$refs.addDialog.open();
    },
    loadProfileCompetencies() {
      this.loading = true;
      this.$api.evaluation.profileCompetenceSearch({
        ...this.filters,
        expand: ['competence'].join(),
        profile_id: this.$route.params.id,
        sort: 'id',
      })
        .then(({data}) => {
          this.profile_competencies = data.profile_competencies;
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteProfileCompetence(profileCompetence) {
      this.loading = true;
      this.$api.evaluation.profileCompetenceDelete({
        ids: [profileCompetence.id],
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Компетенция с профиля успешно удалена'
          });
        })
        .finally(() => {
          this.loadProfileCompetencies();
        })
    },
    filtersChanged() {
      this.loadProfileCompetencies();
    },
    updateProfileCompetence(profileCompetence) {
      this.loading = true;
      this.$api.evaluation.profileCompetenceUpdate({
        id: profileCompetence.id,
        target_score: profileCompetence.target_score,
      })
        .then(data => {
          this.$notify.success({
            title: 'Обновлено',
            message: 'Компетенция с профиля успешно обновлена'
          });
        })
        .finally(() => {
          this.loadProfileCompetencies();
        })
    }
  }
}
</script>

<style lang="scss">
  .profile_competencies-block {
    margin: 25px 0;
  }

  .header-actions {
    display: flex;
    justify-content: space-between;
  }
</style>